import { UISDK } from "@/ui-sdk";
import DataProcessor from "@/dataprocessor";
import { Event } from "@/events";
import { DataProvider } from "./dataProvider";
// import { EmptySDK } from "@/sdk";
import { ShopifySDK } from "@/sdk/shopify";
import { HeliumSDK } from "@/sdk/helium";
import { SubSDK } from "@/sdk/types";
import UIScriptInit from "@/ui-sdk/ui-script";
import { HeliShop } from "@/sdk/helishop";
import type { DataStore as DataStoreType } from ".";
import { HeliumSessionStorage } from "./storage";
import { createElementFromString } from "./utils";
const isProd = !window.location.hostname.includes("localhost");
const preconnectLinks = [
  "https://helium-intelligence-production.s3.eu-north-1.amazonaws.com",
  "https://backend.heliumbuilder.com",
  "https://d21xluao80us9l.cloudfront.net",
];
let DataStore: DataStoreType = "";
class EmptySDK {}
export class Init {
  didInit = false;
  static async init() {
    try {
      const fns = [
        this.initSessionStorage,
        this.addPreConnectLinks,
        this.initSDK,
        this.initSubSDK,
        this.initListeners,
        this.initCachedMemory,
        this.initBrandData,
        this.initPageData,
        this.initUserData,
        this.initMutationObserver,
      ];
      if (window.helium.brandData.isPro) {
        fns.push(this.initUiData, UIScriptInit);
      }
      if (this.didInit) return;
      this.didInit = true;
      //if (isProd) console.log = () => {};
      DataStore = window.helium.datastore;
      fns.forEach(async (fn, i) => {
        try {
          fn();
        } catch (e) {
          console.log("Error initializing pulse-sdk", e, i);
        }
      });
    } catch (e) {
      console.log("Error initializing pulse-sdk", e);
    }
  }
  private static initSessionStorage() {
    if (!window.helium) {
      window.helium = {};
    }
    window.helium.sessionInfo = HeliumSessionStorage.getInstance();
    const storage = window.helium.sessionInfo;
    storage.updateInfo({
      timestamp: Date.now(),
    });
  }
  private static addPreConnectLinks() {
    preconnectLinks.forEach((link) => {
      const linkElement = document.createElement("link");
      linkElement.rel = "preconnect";
      linkElement.href = link;
      document.head.appendChild(linkElement);
    });
  }
  private static initListeners() {
    window.addEventListener("beforeunload", DataStore.unload);
    window.helium.events.subscribe({
      func: (data) => {
        window.helium?.logs?.push?.(Object.assign({ time: Date.now() }, data));
      },
      filters: ["helium-interaction"],
      key: "interaction-events",
    });
  }
  private static initMutationObserver() {
    const targetNode = document.body;

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed

    let prevLink = location.href;
    const callback = () => {
      //console.log("Mutation Happened");
      let timeout: NodeJS.Timeout | undefined = undefined;
      return (mutationList, observer) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          window.helium?.attachAttrs?.();
          const node = document.querySelector(
            '[data-helium-name="product-item"]',
          );
          if (node && false) {
            //console.log("FOUND NODE", node);
            window.helium.datastore.memory.html.product = node;
            window.helium.datastore.memory.html.productHandle =
              node.getAttribute("data-helium-product-item-handle") ||
              node.getAttribute("data-helium-product-handle");
          } else {
            try {
              if (window.helium.productCard) {
                window.helium.datastore.memory.html.product =
                  createElementFromString(window.helium.productCard);
                window.helium.datastore.memory.html.productHandle =
                  window.helium.productCardHandle;
              }
            } catch (e) {
              console.log("Error creating product card", e);
            }
          }
          let navigated = false;
          if (location.href !== prevLink) {
            prevLink = location.href;
            navigated = true;
          }
          window.helium.datastore.refresh(navigated);
        }, 500);
      };
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback());

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
    window.addEventListener("unload", () => observer.disconnect());
  }
  private static initUserData() {
    // TODO: add ref to hari user
  }
  private static initUiData() {
    try {
      console.log("INIT UI DATA");
      if (!window.helium.datastore.memory.html)
        window.helium.datastore.memory.html = {};
      const node = document.querySelector('[data-helium-name="product-item"]');
      if (node && false) {
        window.helium.datastore.memory.html.product = node;
        window.helium.datastore.memory.html.productHandle =
          node.getAttribute("data-helium-product-item-handle") ||
          node.getAttribute("data-helium-product-handle");
      } else {
        window.helium.datastore.memory.html.product = createElementFromString(
          window.helium.productCard,
        );
        // createDefaultProductCard();
      }
    } catch (e) {
      console.log(e);
    }
  }

  private static initCachedMemory() {
    // TODO: getcached memory
    // const fetch = window.fetch;
    // window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    //   const modifiedInit: RequestInit = {
    //     ...init,
    //     cache: "force-cache",
    //   };
    //   return fetch(input, modifiedInit);
    // };
    //const heliumMemory = sessionStorage.getItem("heliumMemory");
    //if (heliumMemory) {
    //window.helium.datastore.memory = JSON.parse(heliumMemory);
    //}
  }

  private static initSDK() {
    // TODO:
    /// attach SDKs for each provider on window helium
    window.helium.ui = new UISDK();
    window.helium.dataprocessor = DataProcessor;
    //datastore: DataStore,
    window.helium.inference = {};
    window.helium.events = Event;

    DataProcessor.init();
  }

  private static async initPageData() {
    const path = window.location.pathname;
    const isPDP = path.includes("/products/");
    if (isPDP) {
      const currentProductHandle = path.split("/").at(-1) as string;
      await window.helium.datastore
        .getProduct({ id: currentProductHandle })
        .catch((e) => console.log("Cannot get product page data", e));
      await window.helium.datastore
        .getTags({ id: currentProductHandle })
        .catch((e) => console.log("Cannot get product page tags", e));

      window.helium.sessionInfo.updateInfo({
        "last-pdp-viewed": currentProductHandle,
      });
    }
    await Init.getPageData({ path });
  }

  private static async getPageData({ path }: { path: string }) {
    const isProductPage = path.includes("/products/");
    const isCollectionPage =
      (!isProductPage && path.includes("/collections/")) ||
      path.includes("/category");
    const isOther = !isProductPage && !isCollectionPage;
    const handle = path.split("/").at(-1);
    let obj = {};
    if (isProductPage || isCollectionPage) {
      let filters = {};

      if (isCollectionPage) {
        // TODO: fetch collection tags  & filters

        if (handle !== "all")
          filters = {
            subcategory: handle,
          };
      }
      obj = {
        handle,
        type: isCollectionPage ? "collection" : "product",
        filters,
      };
    } else if (isOther) {
      obj = {
        handle: path,
        type: "other",
      };
    }
    if (!DataStore.memory.page) DataStore.memory.page = {};
    DataStore.memory.page[path] = obj;
    // DataStore.memory.page[path] = {};
  }

  private static initBrandData = () => {
    const data: MemoryType<"brand"> = {};
    DataStore.memory.brand = window.helium.brandData;
  };

  private static initSubSDK() {
    let sdk: SubSDK;
    const info = window.helium.brandData;

    if (!info.shopify && info.helium) {
      sdk = new HeliumSDK(info);
      //if (info.helium) {
    } else if (info.shopify) {
      sdk = new HeliShop({
        apiKey: window.helium.brandData.apiKey ?? "",
        shopify: {
          shop: window.helium.brandData.shopify.shop,
          storefrontAccessToken:
            window.helium.brandData.shopify.storefrontAccessToken,
        },
        version: 1,
      });
    } else if (window.Shopify) {
      console.error("Shopify Info not provided");
    }
    if (!sdk) {
      sdk = new EmptySDK();
    }
    DataProvider.sdk = sdk;
  }
  private static initHtml() {
    if (!DataStore.memory.html) {
      DataStore.memory.html = {
        product: undefined,
      };
    }
    // TODO: Saved product card html in awas s3
    if (DataStore.memory.html.product) return;
    const origin = window.location.origin;

    if (origin.includes("5173")) {
      DataStore.memory.html.product = document
        .createRange()
        .createContextualFragment(
          `<div class="rounded-xl border bg-card text-card-foreground shadow w-full overflow-hidden h-full sm:col-span-2 lg:col-span-1" data-helium-name="product-item" data-helium-product-handle="satin-stripes-shirt-brown-and-beige-sh227brst"><div class="group relative overflow-hidden"><a href="/demo/DdEK5r/5ieoqn/products/satin-stripes-shirt-brown-and-beige-sh227brst?collection=All"><img src="https://cdn.shopify.com/s/files/1/0795/9858/4101/products/SH227BRST_1.jpg?v=1703694334" alt="Product Image" class="mx-auto aspect-square h-full w-full object-cover object-top" loading="eager" width="1080" height="1440"></a><div class="absolute inset-0 bg-black bg-opacity-0 transition-opacity duration-300 group-hover:bg-opacity-20"></div><div class="absolute right-2 top-2"><button class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80 h-9 w-9 p-2" aria-label="Find Similar"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg></button></div><div class="absolute bottom-2 right-2"><div data-helium-name="cart-cta" class="w-full"><button class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80 h-9 mt-2 w-full p-2 text-center" name="add"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-bag"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg></button></div></div></div><a href="/demo/DdEK5r/5ieoqn/products/satin-stripes-shirt-brown-and-beige-sh227brst?collection=All"><div class="p-2"><h4 class="mt-2 line-clamp-1 text-left text-sm font-semibold">Satin Stripes Shirt - Brown And Beige</h4><p class="w-fit text-xs font-medium">₹1,995</p></div></a></div>`,
        ).firstElementChild;
      return;
    }

    DataStore.memory.html.product =
      document.querySelector(`[data-helium-name="product-item"]`) ??
      document
        .createRange()
        .createContextualFragment(
          `<div class="rounded-xl border bg-card text-card-foreground shadow w-full overflow-hidden col-span-2 h-full sm:col-span-2 lg:col-span-1" data-helium-name="product-item" data-helium-product-handle="satin-stripes-shirt-brown-and-beige-sh227brst"><div class="group relative overflow-hidden"><a href="/demo/KyeIWQ/Xswf43/products/8960161874213?collection=All"><img src="https://cdn.shopify.com/s/files/1/0795/9858/4101/products/SH227BRST_1.jpg?v=1703694334" alt="Product Image" class="mx-auto aspect-square h-full w-full object-cover object-top" loading="eager" width="1080" height="1440"></a><div class="absolute inset-0 bg-black bg-opacity-0 transition-opacity duration-300 group-hover:bg-opacity-20"></div><div class="absolute bottom-0 right-2"><button data-helium-button-type="similar" data-helium-name="button" data-helium-product-handle="satin-stripes-shirt-brown-and-beige-sh227brst" data-helium-listener="true" class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 text-primary-foreground shadow hover:bg-primary/90 h-9 w-9 bg-white p-1" data-helium-button-type="similar" data-helium-name="button" data-helium-product-handle="satin-stripes-shirt-brown-and-beige-sh227brst"><svg width="148" height="40" viewBox="0 0 148 95" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M46.629 12.5086L9.69876 19.0204C4.59975 19.9195 1.19505 24.7819 2.09414 29.8809L11.8618 85.2763C12.7609 90.3753 17.6234 93.78 22.7224 92.8809L59.6527 86.3691C64.7517 85.47 68.1564 80.6076 67.2573 75.5086L57.4896 20.1132C56.5905 15.0142 51.7281 11.6095 46.629 12.5086Z" fill="#E0E0E0" stroke="black" stroke-width="2.8125"></path><path d="M138.301 19.0204L101.371 12.5086C96.2719 11.6095 91.4095 15.0142 90.5104 20.1132L80.7427 75.5086C79.8436 80.6076 83.2483 85.4701 88.3473 86.3691L125.278 92.881C130.377 93.78 135.239 90.3753 136.138 85.2763L145.906 29.8809C146.805 24.7819 143.4 19.9195 138.301 19.0204Z" fill="#E0E0E0" stroke="black" stroke-width="2.8125"></path><path d="M92.75 5.25H55.25C50.0723 5.25 45.875 9.44733 45.875 14.625V80.25C45.875 85.4277 50.0723 89.625 55.25 89.625H92.75C97.9277 89.625 102.125 85.4277 102.125 80.25V14.625C102.125 9.44733 97.9277 5.25 92.75 5.25Z" fill="#999999" stroke="black" stroke-width="2.8125"></path></svg></button></div></div><a href="/demo/KyeIWQ/Xswf43/products/8960161874213?collection=All"><div class="p-2"><h4 class="mt-2 line-clamp-1 text-left text-sm font-semibold">Satin Stripes Shirt - Brown And Beige</h4><p class="w-fit text-xs font-medium">₹1,995</p></div></a></div>`,
        ).firstElementChild;
  }
  static async initCart() {
    if (!DataStore.memory) {
      DataStore.memory = {};
    }

    if (!DataStore.memory.cart) {
      DataStore.memory.cart = {};
    }

    const isShopify = true;
    const origin = window.location.origin;
    const { storeId, orgId } = window.helium.brandData;

    if (origin.includes("5173")) {
      DataStore.memory.cart = democart;
      return;
    }

    let cartUrl: string;
    if (isShopify) {
      cartUrl = `${origin}/cart.js`;
    } else {
      cartUrl = `${origin}/demo/${orgId}/${storeId}/cart`;
    }

    try {
      const res = await fetch(cartUrl);
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      let data;
      const contentType = res.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        data = await res.json();
        console.log("CART DATA: ", data);
      } else {
        const textData = await res.text();
        try {
          data = JSON.parse(textData);
        } catch (parseError) {
          console.error("Failed to parse response as JSON:", parseError);
          throw new Error("Response is not valid JSON");
        }
      }
      console.log("MEMORY CART: ", data);
      DataStore.memory.cart = data;
    } catch (error) {
      console.error("Failed to fetch cart data:", error);
    }
  }
}

const createDefaultProductCard = () => {
  const testProduct = {
    title: "test title",
    description: "test",
    featuredImage: {
      url: "testimg",
      altText: "testimg",
      width: 100,
      height: 100,
    },
    image: "testimg",
    vendor: "test",
    handle: "test",
    priceRange: {
      maxVariantPrice: {
        amount: 100,
        currencyCode: "USD",
      },
      minVariantPrice: {
        amount: 100,
        currencyCode: "USD",
      },
    },
  };
  if (window.helium.datastore.memory.product == undefined)
    window.helium.datastore.memory.product = {};
  window.helium.datastore.memory.product[testProduct.handle] = {
    details: testProduct,
  };

  const newHref =
    window.location.pathname.split("products/")[0] +
    "products/" +
    testProduct.handle;
  const html = `
  <div class="rounded-xl border bg-card text-card-foreground shadow overflow-hidden col-span-1 h-full sm:col-span-2 lg:col-span-1" >
        <a href="${newHref}"/>
    <div class="group relative overflow-hidden">
        <img src='${testProduct.featuredImage.url}' alt='${testProduct.featuredImage.altText}' class="mx-auto aspect-square h-full w-full object-cover object-top" loading="eager" width="1080" height="1440">
      <div class="absolute inset-0 bg-black bg-opacity-0 transition-opacity duration-300 group-hover:bg-opacity-20"></div>
      <div class="absolute bottom-0 right-2">
        <button data-helium-button-type="similar" data-helium-name="button" data-helium-product-handle=${testProduct.handle} data-helium-listener="true" class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 text-primary-foreground shadow hover:bg-primary/90 h-9 w-9 bg-white p-1" >
          <svg width="148" height="40" viewBox="0 0 148 95" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M46.629 12.5086L9.69876 19.0204C4.59975 19.9195 1.19505 24.7819 2.09414 29.8809L11.8618 85.2763C12.7609 90.3753 17.6234 93.78 22.7224 92.8809L59.6527 86.3691C64.7517 85.47 68.1564 80.6076 67.2573 75.5086L57.4896 20.1132C56.5905 15.0142 51.7281 11.6095 46.629 12.5086Z" fill="#E0E0E0" stroke="black" stroke-width="2.8125"></path>
            <path d="M138.301 19.0204L101.371 12.5086C96.2719 11.6095 91.4095 15.0142 90.5104 20.1132L80.7427 75.5086C79.8436 80.6076 83.2483 85.4701 88.3473 86.3691L125.278 92.881C130.377 93.78 135.239 90.3753 136.138 85.2763L145.906 29.8809C146.805 24.7819 143.4 19.9195 138.301 19.0204Z" fill="#E0E0E0" stroke="black" stroke-width="2.8125"></path>
            <path d="M92.75 5.25H55.25C50.0723 5.25 45.875 9.44733 45.875 14.625V80.25C45.875 85.4277 50.0723 89.625 55.25 89.625H92.75C97.9277 89.625 102.125 85.4277 102.125 80.25V14.625C102.125 9.44733 97.9277 5.25 92.75 5.25Z" fill="#999999" stroke="black" stroke-width="2.8125"></path>
          </svg>
        </button>
      </div>
    </div>
      <div class="p-2">
          <h4 class="mt-2 line-clamp-1 text-left text-sm font-semibold">${testProduct.title}</h4>
          <p class="w-fit text-xs font-medium">&#36;${testProduct.priceRange.maxVariantPrice.amount.toLocaleString()}</p>
      </div>
        </a>
  </div>
`;
  const node = document.createElement("div");
  node.setAttribute("data-helium-name", "product-item");
  node.setAttribute("data-helium-product-handle", testProduct.handle);
  node.innerHTML = html;
  const data = DataProvider.cachedResult({
    id: testProduct.handle,
    mode: "product",
    key: "details",
  });
  console.log({ data }, "zzzzzzzzzzzzzzzzzzzz");
  return node;
};
